<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">MAY GOD FORGIVE</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// may-god-forgive_00001.vue?6fb9b33e